import { render, staticRenderFns } from "./book.vue?vue&type=template&id=6474eca2&scoped=true&"
import script from "./book.vue?vue&type=script&lang=ts&"
export * from "./book.vue?vue&type=script&lang=ts&"
import style0 from "./book.vue?vue&type=style&index=0&id=6474eca2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474eca2",
  null
  
)

export default component.exports